import { createSelector } from 'reselect';

import getLocations from './getLocations';
import getOrderInProgress from './getOrderInProgress';
import { resolveOrderInProgressLocation } from '../utils/ordering/resolveOrderInProgressLocation';

export default createSelector(
  [getLocations, getOrderInProgress],
  (locations, orderInProgress) =>
    resolveOrderInProgressLocation({ locations, orderInProgress }),
);
